/* eslint-disable */
export default {
  contactDetails: '連絡先の詳細',
  loadingContact: '連絡先を読み込み中...',
  contactNotFound: '連絡先が見つかりません。',
} as const;

// @key: @#@"contactDetails"@#@ @source: @#@"Contact Details"@#@
// @key: @#@"loadingContact"@#@ @source: @#@"Loading contact..."@#@
// @key: @#@"contactNotFound"@#@ @source: @#@"Contact not found."@#@
